<report-grid-wrapper [header]="header" [headerTag]="'h3'" [accountId]="accountId" [type]="GridType.LIVE_EVENTS" [pollingIntervalSecs]="pollingIntervalSecs" [disableColumnPicker]="true">

	<vb-ui-infinite-scroll-grid [columnDefs]="columnDefs" [getRows]="EventAnalyticsService.getLiveEventRows" [pageSize]="pageSize" [defaultColumnSort]="{ colId: 'startDate', sort: 'desc' }" [fullWidthCellRendererFunc]="showMoreRecordsRowRenderer">
	</vb-ui-infinite-scroll-grid>

</report-grid-wrapper>
